var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeinline = function SvgYoutubeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#F42525"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.097 34.135a6.78 6.78 0 0 1 4.775 4.799C79 43.167 79 52 79 52s0 8.833-1.129 13.067a6.781 6.781 0 0 1-4.774 4.799C68.887 71 52 71 52 71s-16.886 0-21.097-1.134a6.78 6.78 0 0 1-4.774-4.8C25 60.834 25 52 25 52s0-8.833 1.128-13.066a6.78 6.78 0 0 1 4.775-4.8C35.113 33 52 33 52 33s16.886 0 21.097 1.135ZM60.59 52l-14.113 8.02V43.98l14.113 8.02Z",
    fill: "#fff"
  })));
};
export default SvgYoutubeinline;